import React, { Component, useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { DatePicker } from "@material-ui/pickers";
import { setactiveTabObj } from "../../redux/actions/appActions";
import { connect } from "react-redux";
import swal from "sweetalert";
import { useHistory, withRouter, Route, Redirect, Switch } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SettingsIcon from '@material-ui/icons/Settings';
import AddAlarmIcon from '@material-ui/icons/AddAlarm';
import OffileDb from '../../config/pouchDB';
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@material-ui/icons/ThumbDownAltOutlined';
import Loader from "../loaders/loader";
import Questionnaire from "./Questionnaire";
import Calendardatepickerpopup from "./Calendardatepickerpopup.js";
import Calendartimepicker from "./Calendartimepicker.js";
import moment from 'moment';
import Fab from '@material-ui/core/Fab';

// const useStyles = makeStyles((theme) => ({
//   appBar: {
//     position: 'relative',
//   },
//   title: {
//     marginLeft: theme.spacing(2),
//     flex: 1,
//   },
// }));

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

var tempDates = [];
class UserSpecificCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      Date: new Date(),
      title: '',
      startdDate: new Date(),
      endDate: new Date(),
      time: new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
      frequency: 'Daily',
      description: '',
      editFlag: false,
      open: false
    };
  }


  componentDidMount() {
    OffileDb.setDatabase()
    //console.log(this.props.editRemainderObj)
    if (this.props.editRemainderObj != null) {
      this.callEditMode(this.props.editRemainderObj)
    }
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    // console.log(nextProps.editRemainderObj, this.props.editRemainderObj)
    if (nextProps.editRemainderObj != this.props.editRemainderObj) {
      this.callEditMode(nextProps.editRemainderObj)
    }
  }

  callEditMode(obj) {
    this.setState({
      open: true,
      editFlag: true,
      Date: obj.date,
      title: obj.title,
      startdDate: new Date(obj.startdDate),
      endDate: new Date(obj.endDate),
      time: obj.time,
      frequency: obj.frequency,
      description: obj.description,
    })
  }

  onDateChange = (date, str) => {
    console.log(date)
    if (str == 'start') {
      this.setState({ startdDate: date })
    } else {
      this.setState({ endDate: date })
    }
  };

  onTimeChange = (time) => {
    console.log(time)
    this.setState({ time: time })
  };

  handleTextFieldChange = (e) => {
    this.setState({
      title: e.target.value
    });
  }

  // handleTextpillchanges = (e) => {
  //   this.setState({
  //     pillName: e.target.value
  //   });
  // }

  handleTextDescriptionChange = (e) => {
    this.setState({
      description: e.target.value
    });
  }


  handleFrequencyChange = (e) => {
    console.log(e.target.value)
    this.setState({
      frequency: e.target.value
    });
  }

  setReminder() {
    const { t } = this.props;
    var that = this;
    var reminderJson = {
      "id": that.state.editFlag ? this.props.editRemainderObj.id : Math.floor(Math.random() * (10000 - 1) + 1),
      "date": this.state.Date,
      "title": this.state.title,
      "startdDate": this.state.startdDate,
      "endDate": this.state.endDate,
      "time": this.state.time,
      "description": this.state.description,
      "frequency": this.state.frequency,
    }

    if (this.state.title == '') {
      this.alertError("Please give a title to your reminder.")
    } else if (this.state.startdDat == '') {
      this.alertError("Please set a start date")
    } else if (this.state.endDate == '') {
      this.alertError("Please set a end date")
    } else if (this.state.time == '') {
      this.alertError("Please set a reminder time")
    } else {
      var validDates = this.validateCalendar();
      if (validDates) {
        swal({
          text: that.state.editFlag ? ("Are you sure want to update this reminder") : t("Are you sure want to save this reminder"),
          icon: "success",
          buttons: {
            confirm: {
              text: t("yes"),
              value: true,
              visible: true,
              className: "",
              closeModal: true
            },
            cancel: {
              text: t("no"),
              value: false,
              visible: true,
              className: "",
              closeModal: true,
            }
          }
        }).then((val) => {
          console.log(val)
          if (val) {
            OffileDb.getData('userReminderList').then(function (result) {
              if (that.state.editFlag) {
                that.updateRemiderToDB(reminderJson, result)
              } else {
                that.setRemiderToDB(reminderJson, result)
              }
            })
          }
        });
      }
    }
  }

  updateRemiderToDB(reminderJson, result) {
    if (!result.status && result.status != 400) {
      var store = result.data.filter(obj => obj.id != reminderJson.id)
      store.push(reminderJson)
      this.triggerReminder(reminderJson)
      OffileDb.setData('userReminderList', store)
      setTimeout(() => {
        this.handleClose()
      }, 500)
    }
  }

  setRemiderToDB(reminderJson, result) {
    if (!result.status && result.status != 400) {
      var store = result.data
      store.push(reminderJson)
    } else {
      var store = [reminderJson]
    }
    this.triggerReminder(reminderJson)
    OffileDb.setData('userReminderList', store)
    setTimeout(() => {
      this.handleClose()
    }, 500)
  }

  triggerReminder = (reminderJson) => {
    if (window.cordova) {
      console.log(reminderJson)
      var t = reminderJson.time.split(":");
      var hour = parseInt(t[0]);
      var min = parseInt(t[1]);
      var pillDates = this.getAllRemiderDates(reminderJson)
      if (pillDates && pillDates.length > 0) {
        pillDates.forEach(element => {
          window.cordova.plugins.notification.local.hasPermission(function (granted) {
            if (granted == true) {
              window.cordova.plugins.notification.local.schedule({
                title: reminderJson.title,
                text: reminderJson.description,
                trigger: { at: new Date((new Date(element)).getFullYear(), (new Date(element)).getMonth(), (new Date(element)).getDate(), hour, min) }

              });
            } else {
              window.cordova.plugins.notification.local.requestPermission(function (granted) {
                if (granted == true) {
                  window.cordova.plugins.notification.local.schedule({
                    title: reminderJson.title,
                    text: reminderJson.description,
                    trigger: { at: new Date((new Date(element)).getFullYear(), (new Date(element)).getMonth(), (new Date(element)).getDate(), hour, min) }
                  });
                }
              });
            }
          });
        });
      }
    }
  }

  getAllRemiderDates(reminderJson) {
    var tempDates = []
    var startday = new Date(reminderJson.startdDate).getDay();
    var startdate = new Date(reminderJson.startdDate).getDate();
    for (var t = new Date(reminderJson.startdDate); t <= new Date(reminderJson.endDate); t.setDate(t.getDate() + 1)) {
      if (reminderJson.frequency == "Daily") {
        tempDates.push(t.toDateString())
      } else if (reminderJson.frequency == "Weekly") {
        if (startday == t.getDay()) {
          tempDates.push(t.toDateString())
        }
      } else if (reminderJson.frequency == "Monthly") {
        if (startdate == t.getDate()) {
          tempDates.push(t.toDateString())
        }
      }
    }
    console.log(tempDates)
    return tempDates;
  }

  validateCalendar() {
    var validDates = false;
    if (this.state.frequency == 'Daily') {
      var timeDiffCount = this.getTimeDifferenceCount('days');
      if (timeDiffCount < 1) {
        this.alertError("please enter an end date more than a day.")

      } else {
        validDates = true;
      }
    } else if (this.state.frequency == 'Weekly') {
      var timeDiffCount = this.getTimeDifferenceCount('weeks');
      if (timeDiffCount < 1) {
        this.alertError("please enter an end date more than a week.")
      } else {
        validDates = true;
      }
    } else if (this.state.frequency == 'Monthly') {
      var timeDiffCount = this.getTimeDifferenceCount('months');
      if (timeDiffCount < 1) {
        this.alertError("please enter an end date more than a month.")
      } else {
        validDates = true;
      }
    }

    return validDates;
  }

  getTimeDifferenceCount(type) {
    var startDate = this.state.startdDate
    var endDate = this.state.endDate
    var momentSD = moment(startDate, 'D/M/YYYY');
    var momentED = moment(endDate, 'D/M/YYYY');
    var difference = momentED.diff(momentSD, type);
    return difference;
  }

  alertError(err) {
    const { t } = this.props;
    swal({
      text: t(err),
      icon: "warning",
      button: t("ok"),
    })
  }


  handleClickOpen = () => {
    this.setState({
      Date: new Date(),
      title: '',
      startdDate: new Date(),
      endDate: new Date(),
      time: new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
      frequency: 'Daily',
      description: '',
      editFlag: false,
      open: true
    })
  };

  handleClose = () => {
    this.setState({ open: false })
    this.props.handleClose()
  };

  render() {
    const { t } = this.props;
    const { classes, theme } = this.props;
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { color: "#fff", background: this.props.componentbgcolor } : {};
    return (
      <>
        <div className="w-100 text-right reminderbtnholder">
          {
            templateID == 1 ? (
              <Fab color="primary" aria-label="add" onClick={this.handleClickOpen}>
                <AddAlarmIcon />
              </Fab>
            ) : (
              <Button variant="outlined" color="primary" onClick={this.handleClickOpen} className="setreminderbtn">
                <AddAlarmIcon></AddAlarmIcon> {t('Set Reminder')}
              </Button>
            )
          }
        </div>
        <Dialog fullScreen open={this.state.open}  onClose={() => { this.handleClose() }}  >
          <AppBar>
            <Toolbar>
              <Typography variant="h6" >
                {t('Set Reminder')}
              </Typography>
              <IconButton edge="start" color="inherit"  onClick={() => { this.handleClose() }} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Grid container spacing={3} className="gridcontainer">
            <div className="calendartabmainholder remindertabpanel mt-60px ">
              <Grid container spacing={3} className="gridcontainer">
                <Grid container spacing={3} className="gridcontainer informationcardholder">
                  <Grid item xs={templateID == 1 ? 12 : 4} >
                    <p className="getknwtitle text-left">{t('Reminder title')}</p>
                  </Grid>
                  <Grid item xs={templateID == 1 ? 12 : 8} >
                    <TextField id="standard-basic" label="" value={this.state.title} onChange={this.handleTextFieldChange} />
                  </Grid>
                </Grid>

                <Grid container spacing={3} className="gridcontainer informationcardholder">
                  <Grid item xs={templateID == 1 ? 12 : 4} className="">
                    <p className="getknwtitle text-left">{t('Start date')}</p>
                  </Grid>
                  <Grid item xs={templateID == 1 ? 12 : 8} className="">
                    <Calendardatepickerpopup selectedDate={this.state.startdDate} onDateChange={(date) => { this.onDateChange(date, 'start') }}></Calendardatepickerpopup>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="gridcontainer informationcardholder">
                  <Grid item xs={templateID == 1 ? 12 : 4} className="">
                    <p className="getknwtitle text-left">{t('End date')}</p>
                  </Grid>
                  <Grid item xs={templateID == 1 ? 12 : 8} className="">
                    <Calendardatepickerpopup selectedDate={this.state.endDate} onDateChange={(date) => { this.onDateChange(date, 'end') }}></Calendardatepickerpopup>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="gridcontainer informationcardholder">
                <Grid item xs={templateID == 1 ? 12 : 4} className="">
                  <p className="getknwtitle text-left">{t('Reminder frequency')}</p>
                </Grid>
                <Grid item xs={templateID == 1 ? 12 : 8} className="w-100">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    onChange={(e) => { this.handleFrequencyChange(e) }}
                    value={this.state.frequency}
                  >
                    <MenuItem value={'Daily'}>{t('Daily')}</MenuItem>
                    <MenuItem value={'Weekly'}>{t('Weekly')}</MenuItem>
                    <MenuItem value={'Monthly'}>{t('Monthly')}</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid container spacing={3} className="gridcontainer informationcardholder">
                <Grid item xs={templateID == 1 ? 12 : 4} className="">
                  <p className="getknwtitle text-left">{t('Reminder time')}</p>
                </Grid>
                <Grid item xs={templateID == 1 ? 12 : 8} className="">
                  <Calendartimepicker selectedDate={this.state.time} onTimeChange={(time) => { this.onTimeChange(time) }}></Calendartimepicker>
                </Grid>
              </Grid>
              <Grid container spacing={3} className="gridcontainer informationcardholder">
                <Grid item xs={templateID == 1 ? 12 : 4} className="">
                  <p className="getknwtitle text-left">{t('Reminder description')}</p>
                </Grid>
                <Grid item xs={templateID == 1 ? 12 : 8} className="">
                  <TextField
                    id="standard-multiline-static"
                    label=""
                    multiline
                    rows={4}
                    defaultValue=""
                    value={this.state.description}
                    onChange={(e) => { this.handleTextDescriptionChange(e) }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} className="mb-20px">
                <p className="zero p-10px pb-15px text-center">
                  <Button variant="contained" className={templateID == 1 ? 'login_btn' : ''} style={bgStyles} onClick={() => { this.setReminder() }}>{this.state.editFlag ? t("Update Reminder") : t("Set Reminder")}</Button>
                </p>
              </Grid>
              </Grid>
            </div>
          </Grid>
      </Dialog>
      </>
    )
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    activeTabObj: storeState.activeTabObj,
    componentbgcolor: storeState.componentbgcolor
  };
};


const transSerives = withTranslation()(UserSpecificCalendar);
const ThemeServices = withTheme(transSerives);
// const FinalServices = withStyles(useStyles)(ThemeServices);
const routeServices = withRouter(ThemeServices);
export default connect(mapStateToProps, { setactiveTabObj })(routeServices);